type YearActivityGridDay = {
  date: string | null;
};

export type YearActivityGridWeek = {
  days: YearActivityGridDay[];
};

export function addUtcDays(dateStr: string, delta: number): string {
  const [y, m, d] = dateStr.split("-").map(Number);
  const next = new Date(Date.UTC(y, m - 1, d + delta));
  return next.toISOString().slice(0, 10);
}

function utcDayOfWeek(dateStr: string): number {
  return new Date(`${dateStr}T00:00:00Z`).getUTCDay();
}

export function buildYearActivityWeeks({
  endDateStr,
}: {
  endDateStr: string;
}): YearActivityGridWeek[] {
  const windowStart = addUtcDays(endDateStr, -364);
  const windowStartSunday = addUtcDays(windowStart, -utcDayOfWeek(windowStart));
  const endDow = utcDayOfWeek(endDateStr);
  const weekEndSaturday = addUtcDays(endDateStr, 6 - endDow);

  const weeks: YearActivityGridWeek[] = [];
  let weekSunday = windowStartSunday;
  while (weekSunday <= weekEndSaturday) {
    const days: YearActivityGridDay[] = [];
    for (let dayIndex = 0; dayIndex < 7; dayIndex++) {
      const date = addUtcDays(weekSunday, dayIndex);
      const inWindow = date >= windowStart && date <= endDateStr;
      days.push({ date: inWindow ? date : null });
    }
    weeks.push({ days });
    weekSunday = addUtcDays(weekSunday, 7);
  }
  return weeks.filter((week) => week.days.some((day) => day.date !== null));
}

export function mapIdsForYearWindow({ endDateStr }: { endDateStr: string }): string[] {
  const windowStart = addUtcDays(endDateStr, -364);
  const ids: string[] = [];
  let current = windowStart;
  while (current <= endDateStr) {
    ids.push(`${current}-standard`, `${current}-premium`);
    current = addUtcDays(current, 1);
  }
  return ids;
}
